import { FC } from 'react'
import './index.less'
import PerText from '../../Text'
import { PersonalProfileFragment, PublicProfileFragment } from '../../../../types'
import { useTranslation } from 'react-i18next'
import PerFlexRow from '../../FlexRow'
import PerSpacer from '../../Spacer'
import BackgroundBox from '../../BackgroundBox'
import { SmartAvatar } from '../../../../modules/avatar/SmartAvatar'

interface PerProfileHeaderProps {
  profile: PublicProfileFragment | PersonalProfileFragment
  children: React.ReactElement
}

export const PerProfileHeader: FC<PerProfileHeaderProps> = ({ profile, children }) => {
  const { t } = useTranslation()

  return (
    <BackgroundBox r noPadding mb="xs" color="white75">
      <PerFlexRow direction="row" justify="space-between" align="middle">
        <BackgroundBox noShadow noPadding>
          <PerFlexRow align="middle" m="xs">
            <SmartAvatar
              employeeId={profile.employeeId}
              firstName={profile.chosenFirstName ? profile.chosenFirstName : profile.legalFirstName}
              lastName={profile.chosenLastName ? profile.chosenLastName : profile.legalLastName}
              size="xlarge"
            />
            <PerSpacer mx="xl">
              <PerText fontWeight="bold" fontSize="xl" color="error">
                {profile.chosenFirstName ? profile.chosenFirstName : profile.legalFirstName}{' '}
                {profile.chosenLastName ? profile.chosenLastName : profile.legalLastName}
              </PerText>
              <PerText color="secondary" fontSize="m">
                {profile.currentContractLevel && t(`employee.contract.level.${profile.currentContractLevel.level}`)}
              </PerText>
            </PerSpacer>
          </PerFlexRow>
        </BackgroundBox>

        <PerSpacer mx="m">{children}</PerSpacer>
      </PerFlexRow>
    </BackgroundBox>
  )
}
